var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsubscribebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 88,
    r: 88,
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_6126",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 176,
    height: 176
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 88,
    r: 88,
    fill: "#1E1E1E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_6126)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-395.472 31.1984C-359.721 -60.8058 -256.195 -221.127 -128.101 -126.378C32.0172 -7.94156 208.655 285.1 570.318 106.937",
    stroke: "url(#paint0_linear_51_6126)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M-405.685 49.9591C-369.934 -42.0451 -266.408 -202.366 -138.314 -107.617C21.8044 10.8192 198.442 303.86 560.105 125.697",
    stroke: "url(#paint1_linear_51_6126)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M-415.896 68.721C-380.145 -23.2833 -276.619 -183.604 -148.524 -88.8553C11.5934 29.581 188.231 322.622 549.895 144.459",
    stroke: "url(#paint2_linear_51_6126)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-426.109 87.4834C-390.358 -4.5208 -286.832 -164.842 -158.737 -70.0929C1.38053 48.3435 178.019 341.385 539.682 163.222",
    stroke: "url(#paint3_linear_51_6126)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M-436.32 106.245C-400.569 14.2411 -297.043 -146.08 -168.948 -51.331C-8.83041 67.1053 167.808 360.147 529.471 181.984",
    stroke: "url(#paint4_linear_51_6126)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-446.533 125.007C-410.781 33.0029 -307.255 -127.318 -179.161 -32.5692C-19.0433 85.8672 157.595 378.908 519.258 200.746",
    stroke: "url(#paint5_linear_51_6126)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-456.744 143.768C-420.992 51.7642 -317.466 -108.557 -189.372 -13.8079C-29.2542 104.629 147.384 397.67 509.047 219.507",
    stroke: "url(#paint6_linear_51_6126)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-466.956 162.531C-431.205 70.5272 -327.679 -89.794 -199.585 4.95514C-39.4671 123.392 137.171 416.433 498.834 238.27",
    stroke: "url(#paint7_linear_51_6126)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M-477.167 181.292C-441.416 89.288 -337.89 -71.0332 -209.796 23.7159C-49.6781 142.152 126.96 435.193 488.623 257.031",
    stroke: "url(#paint8_linear_51_6126)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-487.38 200.054C-451.629 108.05 -348.103 -52.2714 -220.009 42.4777C-59.891 160.914 116.747 453.955 478.41 275.792",
    stroke: "url(#paint9_linear_51_6126)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M-497.591 218.816C-461.84 126.812 -358.314 -33.5095 -230.22 61.2396C-70.1019 179.676 106.536 472.717 468.199 294.554",
    stroke: "url(#paint10_linear_51_6126)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M-507.804 237.578C-472.053 145.574 -368.527 -14.7476 -240.433 80.0015C-80.3148 198.438 96.3233 491.479 457.986 313.316",
    stroke: "url(#paint11_linear_51_6126)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-518.015 256.339C-482.264 164.335 -378.738 4.01373 -250.644 98.7628C-90.5257 217.199 86.1123 510.24 447.775 332.078",
    stroke: "url(#paint12_linear_51_6126)",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_6126",
    x1: 314.428,
    y1: 362.827,
    x2: -231.706,
    y2: -183.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_6126",
    x1: 304.216,
    y1: 381.587,
    x2: -241.919,
    y2: -164.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_6126",
    x1: 294.005,
    y1: 400.349,
    x2: -252.13,
    y2: -145.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_6126",
    x1: 283.792,
    y1: 419.112,
    x2: -262.342,
    y2: -127.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_6126",
    x1: 273.581,
    y1: 437.874,
    x2: -272.553,
    y2: -108.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_6126",
    x1: 263.368,
    y1: 456.635,
    x2: -282.766,
    y2: -89.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_6126",
    x1: 253.157,
    y1: 475.397,
    x2: -292.977,
    y2: -70.7374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_6126",
    x1: 242.944,
    y1: 494.16,
    x2: -303.19,
    y2: -51.9744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_51_6126",
    x1: 232.733,
    y1: 512.921,
    x2: -313.401,
    y2: -33.2136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_51_6126",
    x1: 222.52,
    y1: 531.682,
    x2: -323.614,
    y2: -14.4518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_51_6126",
    x1: 212.309,
    y1: 550.444,
    x2: -333.825,
    y2: 4.31011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_51_6126",
    x1: 202.096,
    y1: 569.206,
    x2: -344.038,
    y2: 23.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_51_6126",
    x1: 191.885,
    y1: 587.967,
    x2: -354.249,
    y2: 41.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribebg);
export default __webpack_public_path__ + "static/media/unsubscribebg.3de7b6e2f97d9515517e8964a2154c78.svg";
export { ForwardRef as ReactComponent };